// Module-level handle on the loaded card catalog for surfaces that sit
// outside the screen prop chain (the header's Notifications menu). Player
// avatars are Sorcery card ids, so resolving one to an image needs the
// catalog; threading `sorceryCards` through every AppHeader caller for a
// single lookup is the alternative this replaces. app.jsx registers the
// catalog once it has loaded.
let cards = null;

export function setSorceryCards(next) {
  cards = Array.isArray(next) ? next : null;
}

export function getSorceryCards() {
  return cards;
}
